import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <TopicsSection />
        <CardsSection />
        <AboutSection />
        <UpdatesSection />
        <CarouselSection />
        <ContactSection />
        <MediaSection />
        <FAQSection />
        <AppSection />
        <RankingSection />
        <CommentsSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}